import { 
  LayoutDashboard, 
  Clock, 
  Users, 
  Building2, 
  MapPin, 
  Upload, 
  Megaphone, 
  Bell,
  Lock,
  CheckCircle,
  CalendarRange,
  Handshake,
  FileOutput
} from "lucide-react";
import { NACIcon } from "@/components/NACIcon";
import { Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from "@/components/ui/sidebar";

const menuItems = [
  { title: "System Overview", url: "/admin/overview", icon: LayoutDashboard },
  { title: "Flight Updates", url: "/admin/flight-updates", icon: Clock },
  { title: "Schedule Import AI", url: "/schedule-tool", icon: CalendarRange },
  { title: "Users", url: "/admin/users", icon: Users },
  { title: "Organizations", url: "/admin/organizations", icon: Building2 },
  { title: "Cities", url: "/admin/cities", icon: MapPin },
  { title: "Ground Handling", url: "/admin/ground-handling", icon: Handshake },
  { title: "Aircraft Types", url: "/admin/aircraft-types", icon: NACIcon },
  { title: "Upload CSV", url: "/admin/upload-schedule", icon: Upload },
  { title: "Banners", url: "/admin/banners", icon: Megaphone },
  { title: "Announcements", url: "/admin/announcements", icon: Bell },
  { title: "Change Password", url: "/admin/change-password", icon: Lock },
  { title: "Fix Unconfirmed Users", url: "/admin/fix-users", icon: CheckCircle },
  { title: "PDF Normaliser", url: "/tools/pdf-normaliser", icon: FileOutput },
];

export function AdminSidebar() {
  const { state } = useSidebar();
  const location = useLocation();
  const isCollapsed = state === "collapsed";

  const isActive = (url: string) => {
    if (url === "/admin/overview") {
      return location.pathname === "/admin" || location.pathname === "/admin/overview";
    }
    return location.pathname === url;
  };

  return (
    <Sidebar collapsible="icon" className="border-r bg-org-sidebar-bg">
      <SidebarContent className="bg-org-sidebar-bg">
        <SidebarGroup>
          <SidebarGroupLabel>Admin Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <Link to={item.url} className="flex items-center gap-3">
                      <item.icon className="h-4 w-4" />
                      {!isCollapsed && <span>{item.title}</span>}
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
